<template>
  <b-modal
    :visible="showModal"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    @hidden="$emit('close-modal', 'showDeleteModal')"
  >
    <div class="d-flex">
      <div style="width: 15%" @click="closeModal">
        <img src="../../assets/img/feedbackform/deletemodal.svg" alt="" />
      </div>
      <div style="width: 85%">
        <div class="d-flex justify-content-between align-items-center">
          <div class="pff-modal-heading">{{ deleteData.title }}</div>
          <div class="pointer">
            <img
              @click="$emit('close-modal', 'showDeleteModal')"
              class="rotate-on-hover"
              src="../../assets/img/feedbackform/x-close.svg"
              alt=""
            />
          </div>
        </div>
        <div class="mt-3 pff-modal-sub-heading">
          {{ deleteData.message1 }}
          <span class="modalnamebluetext"> “{{ deleteData.data }}“</span>
          {{ deleteData.message2 }}
        </div>
      </div>
    </div>
    <!-- <hr class="my-3" /> -->

    <div class="d-flex align-items-center justify-content-end mt-3">
      <div class="newoutline">
        <b-button
          variant="padding-4-21 outline-primary mr-3"
          @click="closeModal"
          >Cancel</b-button
        >
      </div>

      <div class="newprimarybtn">
        <b-button class="padding-4-21" @click="deleteJob">Delete</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "DeleteModal",
  props: {
    showModal: Boolean,
    deleteData: Object,
  },
  methods: {
    closeModal() {
      this.$emit("closeDeleteJd", false);
    },
    deleteJob() {
      this.$emit("delete-event");
    },
  },
};
</script>

<style></style>
